import { createContext, FC, ReactNode } from 'react';

export const MenuCloseContext = createContext<(() => void) | null>(null);

interface Props {
  children: ReactNode;
  value: (() => void) | null;
}

export const MenuProvider: FC<Props> = ({ children, value }) => {
  return <MenuCloseContext.Provider value={value}>{children}</MenuCloseContext.Provider>;
};
